import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import {AngularFireStorage} from '@angular/fire/storage';
import {FlatManagerService} from '../../service/flat-manager.service';
import {Flat} from '../../models/flat.model';
import {UploadedImgInfo} from '../../input/custom-drop-zone/custom-drop-zone.component';

@Component({
  selector: 'app-flat-modal',
  templateUrl: './flat-modal.component.html',
  styleUrls: ['./flat-modal.component.scss']
})
export class FlatModalComponent implements OnInit {

  activeTabIndex = 0;
  selectedFlat: Flat;
  form: FormGroup;
  startDate = new Date().getTime();
  @ViewChild('picker') datePicker;

  constructor(
    private fb: FormBuilder,
    private flatManagerService: FlatManagerService,
    private dialogRef: MatDialogRef<FlatModalComponent>,
    private storage: AngularFireStorage,
    @Inject(MAT_DIALOG_DATA) flat: Flat) {

    this.selectedFlat = flat;

    if (!this.selectedFlat) {
      this.selectedFlat = new Flat();
    }

    this.form = fb.group({
      name: [this.selectedFlat.name, Validators.required],
      size: [this.selectedFlat.size, Validators.required],
      price: [this.selectedFlat.price, Validators.required],
      level: [this.selectedFlat.level, Validators.required],
      numberOfRooms: [this.selectedFlat.numberOfRooms],
      longitude: [this.selectedFlat.longitude, Validators.required],
      latitude: [this.selectedFlat.latitude, Validators.required],
      side: [this.selectedFlat.side],
      isOffice: [this.selectedFlat.isOffice],
      coordinateX: [this.selectedFlat.coordinateX],
      coordinateY: [this.selectedFlat.coordinateY],
      flatAreas: [this.selectedFlat.flatAreas],
      garden: [this.selectedFlat.garden],
      reserved: [this.selectedFlat.reserved],
      soldOut: [this.selectedFlat.soldOut],
    });

    // this.flatManagerService.selectedFlat.subscribe((selectedFlat) => {
    //   this.selectedFlat = selectedFlat;
    // });

  }


  ngOnInit() {

  }

  onPointSelected(event) {
    this.form.controls['level'].patchValue(event.level);
    this.form.controls['latitude'].patchValue(event.lat);
    this.form.controls['longitude'].patchValue(event.lng);
    this.selectedFlat.level = event.level;
    this.selectedFlat.latitude = event.lat;
    this.selectedFlat.longitude = event.lng;
  }

  onFrontagePositionSelected(event) {
    this.form.controls['side'].patchValue(event.side);
    this.form.controls['coordinateX'].patchValue(event.x);
    this.form.controls['coordinateY'].patchValue(event.y);
    this.selectedFlat.side = event.side;
    this.selectedFlat.coordinateX = event.x;
    this.selectedFlat.coordinateY = event.y;
  }

  openCalendar() {
    this.datePicker.open();
  }

  save() {

    if (!this.form.valid) {
      return;
    }

    if (this.selectedFlat.id) {
      this.flatManagerService.editFlat(<Flat>{...this.selectedFlat, ...this.form.value, updatedAt: new Date().getTime()});
    } else {
      const createdAt = this.form.value.createdAt ? this.form.value.createdAt : new Date().getTime();
      this.flatManagerService.createFlat(<Flat>{...this.form.value, createdAt, updatedAt: new Date().getTime()});
    }

    this.dialogRef.close(this.form.value);
  }

  close() {
    this.dialogRef.close();
  }

  onSelectedTabChanged(event) {
    this.activeTabIndex = event.index;
  }

  onFlatContentChanged(value) {
    this.form.controls['body'].patchValue(value);
  }

  deleteLayoutImage(imageKey: string) {
    const fileRef = this.storage.ref(this.selectedFlat[imageKey + 'ImageUrlFilePath']);
    fileRef.delete();
    this.selectedFlat[imageKey + 'ImageUrl'] = '';
    this.selectedFlat[imageKey + 'ImageUrlFilePath'] = '';
    this.flatManagerService.editFlat(this.selectedFlat);
  }


  onUploadFinished(event: UploadedImgInfo, imageKey: string) {
    this.selectedFlat[imageKey + 'ImageUrl'] = event.imageUrl;
    this.selectedFlat[imageKey + 'ImageUrlFilePath'] = event.imageUrlFilePath;
    this.flatManagerService.editFlat(this.selectedFlat);
  }

  onLayoutImageUploadFinished(event) {
    this.onUploadFinished(event, 'layout');
  }


  onSalesImageUploadFinished(event) {
    this.onUploadFinished(event, 'sales');
  }


  onBuildingInImageUploadFinished(event) {
    this.onUploadFinished(event, 'buildingIn');
  }



}
